import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LinesPeriodPicker from './LinesPeriodPicker';
import { fetchLineDataInformation } from 'redux/lineDataInformation/LineDataInformationActions';

const mapDispatchToProps = dispatch => ({
  lineDataActions: bindActionCreators({ fetchLineDataInformation }, dispatch)
});

export default connect(null, mapDispatchToProps)(LinesPeriodPicker);



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/linesData/linesPeriodPicker/LinesPeriodPickerConnector.js